<template>
  <section class="wrapper p-4">
    <h1>Форум</h1>
    <p>Статичная страница для сайта voltag.ru.</p>
  </section>
</template>
